// extracted by mini-css-extract-plugin
module.exports = {"component":"predefined-search_component__IrOxh"};